/**
 * Height of the window that shows the report preview.
 * The old box was a fixed 720px, shorter than one page. The window now opens
 * at least a full page tall, grows with a large screen, and can be pulled
 * further down.
 */

/** The handle cannot shrink the window below the old preview. */
export const REPORT_PREVIEW_HEIGHT_MIN = 720;
/** Opens at least this tall: about one full page. */
export const REPORT_PREVIEW_HEIGHT_FLOOR = 1120;
/** Automatic height stops here. The handle can still go higher. */
export const REPORT_PREVIEW_HEIGHT_CAP = 1600;
export const REPORT_PREVIEW_HEIGHT_MAX = 2400;
export const REPORT_PREVIEW_HEIGHT_STEP = 80;
/** Bars above the preview: app, patient, tabs, and the report actions. */
const VIEWPORT_CHROME = 128;

export function reportPreviewHeight(viewportHeight: number): number {
  const fitted = Math.round(viewportHeight) - VIEWPORT_CHROME;
  return Math.min(REPORT_PREVIEW_HEIGHT_CAP, Math.max(REPORT_PREVIEW_HEIGHT_FLOOR, fitted));
}

export function clampReportPreviewHeight(height: number): number {
  return Math.min(
    REPORT_PREVIEW_HEIGHT_MAX,
    Math.max(REPORT_PREVIEW_HEIGHT_MIN, Math.round(height)),
  );
}
